import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { useHistory } from 'react-router-dom';
import { useButton, useI18n } from '~Hooks';
import { Box, Button, TransparentButton } from '~Styles';
import Heading from '~ComponentsImproved/Typography/Heading';
import { handyBreakpoint } from '~Styles/breakpoints';

import bLogo from '~Assets/Logos/b_logo_black.svg';

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const Wrapper = styled(Box)`
  background-color: var(--colorBlueGray1200);
  color: var(--colorWhite);
  height: 100vh;
  width: 100%;
  position: fixed;
  z-index: 99;
`;

const ContentSide = styled(Box)`
  animation: ${fadeIn} 0.3s ease-in-out 0.1s forwards;
  opacity: 0;
  margin-bottom: 10%;
  width: 400px;
  text-align: center;

  ${handyBreakpoint} {
    margin-bottom: auto;
  }
`;

const BLogoImg = styled.img`
  width: 48px;
  height: 48px;
  object-fit: contain;
  filter: invert(1);
`;

const NotFound = () => {
  const { i18n } = useI18n();
  const history = useHistory();

  const backButton = useButton({ onClick: () => history.push('/venues') });

  return (
    <Wrapper display="flex" alignItems="center" justifyContent="center">
      <ContentSide display="flex" flexDirection="column" alignItems="center" padding="large">
        <BLogoImg src={bLogo} alt="Baemingo" />
        <Heading level={2} color="var(--colorWhite)" top={12} bottom={24}>
          {i18n('NF.Title')}
        </Heading>
        <Button {...backButton} size="small">
          {i18n('NF.BackToStart')}
        </Button>
      </ContentSide>
    </Wrapper>
  );
};

export default NotFound;
